import { render, staticRenderFns } from "./DetailItemClassf.vue?vue&type=template&id=39506adf&scoped=true&"
import script from "./DetailItemClassf.vue?vue&type=script&lang=js&"
export * from "./DetailItemClassf.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39506adf",
  null
  
)

export default component.exports